import { render, staticRenderFns } from "./Counts.vue?vue&type=template&id=56abb36d"
import script from "./Counts.vue?vue&type=script&lang=js"
export * from "./Counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports